// frontend/src/components/admin/ErrorCargaAdmin.tsx
// Si el chunk del panel no se puede descargar (sin red, o un deploy borró el
// archivo viejo), React desmontaría toda la app: se muestra un aviso con
// opciones en su lugar.

import { Component, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props { children: ReactNode; onVolver: () => void }

export class ErrorCargaAdmin extends Component<Props, { error: boolean }> {
  state = { error: false };

  static getDerivedStateFromError() {
    return { error: true };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center" style={{ backgroundColor: 'var(--color-sgcc-surface)' }}>
        <AlertTriangle size={40} strokeWidth={1.6} style={{ color: '#b45309' }} />
        <p className="text-base font-bold text-[#001e40]">No se pudo abrir la administración</p>
        <p className="text-sm text-[#43474f] max-w-xs">Verifique la conexión. Si se acaba de publicar una versión nueva, recargar lo soluciona.</p>
        <div className="flex gap-2 w-full max-w-xs">
          <button className="flex-1 h-11 rounded-[12px] text-sm font-semibold text-white tap-active" style={{ backgroundColor: '#001e40' }}
            onClick={() => window.location.reload()}>Recargar</button>
          <button className="flex-1 h-11 rounded-[12px] text-sm font-semibold tap-active" style={{ backgroundColor: 'rgba(60,60,67,0.1)', color: '#43474f' }}
            onClick={() => { this.setState({ error: false }); this.props.onVolver(); }}>Volver</button>
        </div>
      </div>
    );
  }
}
